import { alpha, Box, Button, Container, Stack } from "@mui/material";
import { useTheme } from "@mui/system";
import Iconify from "src/components/iconify";
import { useGetWorkspacesQuery } from "src/context/api/workspaces";
import { useCurrentWorkspace } from "src/context/reducers/app-settings";
import { useRouter } from "src/routes/hooks";
import { tr } from "./i18n";

// Same look as the 404 page (src/pages/error/404.tsx)
const buttonSx = {
    backgroundColor: "rgba(236, 255, 159, 1)",
    ":hover": { backgroundColor: "rgba(236, 255, 159, .5)" },
    color: "#17191a",
};

/** Shown instead of the page when the workspace is not the test client */
export default function BidStratTestingUnavailable({ testBqTable }: { testBqTable: string }) {
    const theme = useTheme();
    const router = useRouter();
    const workspace: any = useCurrentWorkspace();
    const { data: workspaces } = useGetWorkspacesQuery(null);
    const testWorkspace = workspaces?.find((w: any) => w.bqTable === testBqTable);

    // WorkspaceGuard (src/providers/workspace.tsx) applies the ?workspace= param
    const switchToTestWorkspace = () => {
        if (!testWorkspace) return;
        router.push(`/brand/brand-shield/bid-strat-testing?workspace=${testWorkspace.id}`);
    };

    return (
        <Container style={{ width: "60%", display: "flex", justifyContent: "center", textAlign: "center", marginTop: "100px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: 5, alignItems: "center", paddingInline: "20%" }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                    <h3>{tr("page.unavailable_title")}</h3>
                    <p style={{ textWrap: "wrap" }}>{tr("page.unavailable_description")}</p>
                </Box>

                <Box
                    sx={{
                        width: 240,
                        height: 240,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: `linear-gradient(135deg, ${alpha(theme.palette.error.main, 0.16)}, ${alpha(theme.palette.error.main, 0)})`,
                    }}
                >
                    <Iconify
                        icon="mdi:minus-circle"
                        width={128}
                        sx={{ color: theme.palette.error.main }}
                    />
                </Box>

                <Stack direction="row" gap={2}>
                    {testWorkspace && (
                        <Button variant="contained" sx={buttonSx} onClick={switchToTestWorkspace}>
                            {tr("page.switch_to_test")}
                        </Button>
                    )}
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={() => router.push(`/brand/search-performance/overview?workspace=${workspace?.id ?? ""}`)}
                    >
                        {tr("page.go_back")}
                    </Button>
                </Stack>
            </Box>
        </Container>
    );
}
